import { render, staticRenderFns } from "./HiperDia.vue?vue&type=template&id=678eae78"
import script from "./HiperDia.vue?vue&type=script&lang=js"
export * from "./HiperDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports